function EmptyCommand() {
  return '';
}

export default EmptyCommand;



// WEBPACK FOOTER //
// ./src/commands/EmptyCommand.js